import React from 'react';
import Header from './components/general components/Header';
import RouteList from './routes';
import { createTheme, adaptV4Theme, StyledEngineProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline"; 
import ThemeProvider from "./context/DarkMode/index";

function App() {

  const theme = createTheme(adaptV4Theme({
    palette: {
      mode: "dark",
    },
  }));

  return (
    <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
        <CssBaseline />
        <RouteList />
    </ThemeProvider>
  </StyledEngineProvider>

  );
}

export default App;
